export default function getLocationHostSiteName() {
  return (
    document.location.hostname.split('.').reverse()[1] ||
    document.location.hostname.split('.').reverse()[0]
  );
}
